export default [
  {label: 'Inventory', value: 'Inventory'},
  {label: 'Marketing', value: 'Marketing'},
  {label: 'Taxes', value: 'Taxes'},
  {label: 'Payroll', value: 'Payroll'},
  {label: 'Debt Refinancing', value: 'Debt Refinancing'},
  {label: 'Business Expansion', value: 'Business Expansion'},
  {label: 'New Location', value: 'New Location'},
  {label: 'Renovation', value: 'Renovation'},
  {label: 'Equipment Purchase', value: 'Equipment Purchase'},
  {label: 'Equipment Repair', value: 'Equipment Repair'},
  {label: 'Hiring Employees', value: 'Hiring Employees'},
  {label: 'Other', value: 'Other'},
  {label: 'Misc. Business Expenses', value: 'Misc. Business Expenses'},
  {label: 'Materials', value: 'Materials'},
  {label: 'Working Capital', value: 'Working Capital'}
];
